import {useEffect, useState} from 'react';

import {EMMAI_OFFICE_AND_PRACTITIONER_ACTIVITY_FORM_STEPS} from '../../../../../../../const';

export const useRestitutionAccordion = errors => {
  const [expanded, setExpanded] = useState(EMMAI_OFFICE_AND_PRACTITIONER_ACTIVITY_FORM_STEPS.SECOND_STEP);

  useEffect(() => {
    if (errors.officeInformation) {
      setExpanded(EMMAI_OFFICE_AND_PRACTITIONER_ACTIVITY_FORM_STEPS.FIRST_STEP);
    }
  }, [errors]);

  const toggle = step => setExpanded(prev => (prev === step ? null : step));

  return {expanded, toggle};
};
